"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqData = [{
  question: "¿Qué documentos mexicanos puedo gestionar con una apostilla para usar en el extranjero?",
  answer: "Gestionamos la apostilla de actas de nacimiento, matrimonio, títulos profesionales y antecedentes penales para que sean válidos en España, EE.UU. y más de 120 países."
}, {
  question: "¿Cuánto tiempo tardan los trámites de apostilla?",
  answer: "El proceso suele tomar entre 3 a 7 días hábiles dependiendo de la entidad emisora. Contamos con servicios exprés para casos de urgencia migratoria."
}, {
  question: "¿Es seguro el envío de mis documentos para trámites de apostilla a otros países?",
  answer: "Totalmente. Trabajamos con DHL y FedEx para envíos internacionales, proporcionando rastreo en tiempo real y protocolos de manejo seguro para documentos originales."
}, {
  question: "¿Necesito enviar el documento original físico para mis trámites de apostilla?",
  answer: "Sí, la mayoría de las dependencias en México requieren el documento original con firma autógrafa para validar la apostilla. Nosotros coordinamos la recolección en tu domicilio."
}, {
  question: "¿Cuál es la diferencia entre apostilla de actas de nacimiento y antecedentes penales?",
  answer: "La apostilla de acta de nacimiento certifica tu identidad y origen, mientras que la de antecedentes penales valida tu conducta legal. Ambos son trámites de apostilla esenciales pero se gestionan ante dependencias distintas en México."
}, {
  question: "¿Ofrecen servicios de traducción certificada?",
  answer: "Sí, realizamos traducciones por peritos traductores autorizados, requisito indispensable para que tus documentos mexicanos sean aceptados en países de habla no hispana."
}, {
  question: "¿Sus servicios sirven para trámites de nacionalidad en España?",
  answer: "Efectivamente. Especializamos nuestra gestión en actas para la Ley de Memoria Democrática y otros procesos de residencia o nacionalidad en territorio español."
}, {
  question: "¿Qué es una apostilla de acta de nacimiento?",
  answer: "La apostilla de acta de nacimiento certifica tu identidad y origen para que sea válida legalmente en el extranjero. Es un trámite esencial que se gestiona ante las dependencias correspondientes en México."
}, {
  question: "¿Cómo obtener antecedentes no penales apostillados?",
  answer: "Para obtener antecedentes no penales apostillados, gestionamos la validación de tu conducta legal ante las autoridades mexicanas para que el documento sea aceptado en procesos migratorios internacionales."
}, {
  question: "¿Cuál es el costo de apostillas de documentos mexicanos?",
  answer: "El costo varía según el tipo de documento y la urgencia del trámite. Ofrecemos presupuestos personalizados que incluyen la gestión integral y el envío seguro por mensajería internacional."
}];
export default function Faqs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "inLanguage": "es-MX",
    "mainEntity": faqData.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };
  return <section data-section-id="26061" id="preguntas-frecuentes" ref={ref} className={cn("relative w-full py-20 lg:py-32 overflow-hidden", "bg-background text-foreground", "transition-opacity duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full opacity-20 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary/10 rounded-lg blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-secondary/5 rounded-lg blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold font-default tracking-tight text-foreground mb-4">
              Preguntas frecuentes sobre apostillas
            </h2>
            <p className="text-muted-foreground text-lg font-default">
              Aquí resolvemos las dudas más comunes de mexicanos que necesitan gestionar documentos para usarlos en España, Estados Unidos y otros países.
            </p>
            <script type="application/ld+json" dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqSchema)
          }} />
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border bg-card/50 backdrop-blur-sm px-6 rounded-xl shadow-sm hover:border-primary/40 transition-colors duration-300">
                <AccordionTrigger className="text-left font-default text-lg font-medium text-foreground hover:text-primary hover:no-underline py-6">
                  <h3>{item.question}</h3>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6 font-default">
                  <p>{item.answer}</p>
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}